import type {
  AccidentReportViewModel,
  VehicleKey,
} from "#accident-statement/schema";
import type { TrackEventProps, TrackingValue } from "@naf/teamscheme";
import React, { useEffect, useContext } from "react";
import type { ReportLinkSource } from "./ReportLinkSource";

export function useTrackContext(
  attribute: string,
  value: TrackingValue | null | undefined,
) {
  const tracking = useTracking();
  useEffect(() => {
    if (value !== null && value !== undefined) {
      tracking.context({ [attribute]: value });
    }
  }, [attribute, tracking, value]);
}

export interface ITrackingContext {
  event(props: TrackEventProps): void;
  pageView({ title, path }: { title: string; path: string }): void;
  reportLoad(report: AccidentReportViewModel, party: VehicleKey): void;
  experiment(experimentName: string): void;
  appLoad(): void;
  context(contextObject: { [attribute: string]: TrackingValue }): void;
  reportLinkOpened(source: ReportLinkSource): void;
}
export const TrackingContext = React.createContext<ITrackingContext | null>(
  null,
);

export function useTracking() {
  const context = useContext(TrackingContext);
  if (!context) {
    throw new Error("No AppTrackingContext found!");
  }
  return context;
}
